import { styled } from '@linaria/react';
import { NoStyleButton } from '@daedalus/atlas/helpers/NoStyleButton';
import { InputText } from '@daedalus/atlas/InputText/';
import { Text } from '@daedalus/atlas/Text';
import { cssTheme } from '@daedalus/atlas/themes';
type ListType = 'overlay' | 'popover';

/**
 * Input field
 */
// TODO: Migrate to Linaria after atlas migration
const _exp = /*#__PURE__*/() => InputText;
export const SearchFieldMobile = /*#__PURE__*/styled(_exp())({
  name: "SearchFieldMobile",
  class: "ss9gqc9",
  propsAsIs: true
});

/**
 * Suggestions list
 */
export const SuggestionsListElement = /*#__PURE__*/styled('div')({
  name: "SuggestionsListElement",
  class: "s1ipjhhs",
  propsAsIs: false
});
const _exp7 = /*#__PURE__*/() => ({
  listType
}) => listType === 'popover' ? 0 : cssTheme.layout.spacing.s300;
export const SuggestionsListSection = /*#__PURE__*/styled('div')({
  name: "SuggestionsListSection",
  class: "s1kobihg",
  propsAsIs: false,
  vars: {
    "s1kobihg-0": [_exp7()]
  }
});

/**
 * Suggestions item
 */
const _exp11 = /*#__PURE__*/() => ({
  isFocused
}) => isFocused ? cssTheme.colors.background.neutral.c050 : 'none';
export const SuggestionElement = /*#__PURE__*/styled('div')({
  name: "SuggestionElement",
  class: "s1mi0iaf",
  propsAsIs: false,
  vars: {
    "s1mi0iaf-0": [_exp11()]
  }
});
export const SuggestionContentWrapper = /*#__PURE__*/styled('div')({
  name: "SuggestionContentWrapper",
  class: "sdmf5m8",
  propsAsIs: false
});
export const SuggestionIconWrapper = /*#__PURE__*/styled('div')({
  name: "SuggestionIconWrapper",
  class: "s1kb9tqb",
  propsAsIs: false
});
export const SuggestionTextElement = /*#__PURE__*/styled('div')({
  name: "SuggestionTextElement",
  class: "sr5l9ot",
  propsAsIs: false
});
export const SuggestionTextElementDetail = /*#__PURE__*/styled('div')({
  name: "SuggestionTextElementDetail",
  class: "sgjh3s3",
  propsAsIs: false
});
export const CloseIconWrapper = /*#__PURE__*/styled('div')({
  name: "CloseIconWrapper",
  class: "c1w9njnb",
  propsAsIs: false
});
export const UserHistoryHeadingElement = /*#__PURE__*/styled('h4')({
  name: "UserHistoryHeadingElement",
  class: "uecqj3z",
  propsAsIs: false
});
export const SuggestionTextWrapper = /*#__PURE__*/styled('div')({
  name: "SuggestionTextWrapper",
  class: "su8v01a",
  propsAsIs: false
});
export const SuggestionTypeLabel = /*#__PURE__*/styled('span')({
  name: "SuggestionTypeLabel",
  class: "sws3d2s",
  propsAsIs: false
});

/**
 * Nearby properties option
 */
const _exp28 = /*#__PURE__*/() => SuggestionIconWrapper;
export const NearbyIconWrapper = /*#__PURE__*/styled(_exp28())({
  name: "NearbyIconWrapper",
  class: "n337ehm",
  propsAsIs: true
});
const _exp31 = /*#__PURE__*/() => NoStyleButton;
export const NearbySuggestionButton = /*#__PURE__*/styled(_exp31())({
  name: "NearbySuggestionButton",
  class: "n106n4ib",
  propsAsIs: true
});
const _exp32 = /*#__PURE__*/() => Text;
export const NearbySuggestionTextElement = /*#__PURE__*/styled(_exp32())({
  name: "NearbySuggestionTextElement",
  class: "n1s78y3y",
  propsAsIs: true
});
const _exp33 = /*#__PURE__*/() => SuggestionTextWrapper;
export const NearbySuggestionTextWrapper = /*#__PURE__*/styled(_exp33())({
  name: "NearbySuggestionTextWrapper",
  class: "n1sv8059",
  propsAsIs: true
});

// No Results Found
const _exp34 = /*#__PURE__*/() => ({
  listType
}) => listType === 'popover' ? cssTheme.layout.spacing.s400 : cssTheme.layout.spacing.s950;
export const DestinationPickerNoResultsWrapper = /*#__PURE__*/styled('div')({
  name: "DestinationPickerNoResultsWrapper",
  class: "dewa4kx",
  propsAsIs: false,
  vars: {
    "dewa4kx-0": [_exp34()]
  }
});
export const DestinationPickerInputWrapper = /*#__PURE__*/styled('div')({
  name: "DestinationPickerInputWrapper",
  class: "d5521fz",
  propsAsIs: false
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");